import React from 'react';
import { CalendarDays } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { formatTourDate, localeFor } from '@/lib/utils';

export const TourDateBadge = ({ tour }) => {
  const { language, t } = useLanguage();
  const hasDate = Boolean(tour.next_departure);
  if (!hasDate) return null;
  const text = hasDate ? `${t('tour.next_date')}: ${formatTourDate(tour.next_departure, language)}` : t('tour.dates_soon');
  return (
    <div
      data-testid={`tour-next-date-${tour.slug}`}
      className={`absolute bottom-3 left-3 max-w-[calc(100%-1.5rem)] inline-flex items-center gap-1.5 rounded-2xl px-3 py-1.5 leading-tight text-[10px] sm:text-xs font-bold tracking-wide text-white shadow-lg backdrop-blur-md ${hasDate ? 'bg-gray-900/75' : 'bg-gray-700/70'}`}
    >
      <CalendarDays size={14} className={`flex-shrink-0 ${hasDate ? 'text-orange-400' : 'text-gray-300'}`} />
      <span className="whitespace-normal">{text.toLocaleUpperCase(localeFor(language))}</span>
    </div>
  );
};
